import { render, staticRenderFns } from "./techdata.vue?vue&type=template&id=35fe9dc4&scoped=true&lang=html"
import script from "./techdata.vue?vue&type=script&lang=js"
export * from "./techdata.vue?vue&type=script&lang=js"
import style0 from "./techdata.vue?vue&type=style&index=0&id=35fe9dc4&prod&lang=css"
import style1 from "./techdata.vue?vue&type=style&index=1&id=35fe9dc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe9dc4",
  null
  
)

export default component.exports